import React from 'react';
import ui from '../../styles/ui.module.css';
import st from './SectionHeader.module.css';

export function SectionHeader({ kicker, title, subtitle, align = 'left' }) {
  return (
    <div className={`${st.root} ${align === 'center' ? st.center : ''}`}>
      {kicker ? <div className={ui.kicker}>{kicker}</div> : null}
      <h2 className={ui.h2}>{title}</h2>
      {subtitle ? <p className={`${ui.p} ${st.subtitle}`}>{subtitle}</p> : null}
    </div>
  );
}

